import { useEffect, useState } from 'react';
import { gate } from 'hub-http/gates';
import Raven from 'raven-js';
import { getFeatureWithRPC } from '../../common/api/featuresApi';
import { getUserInfo } from '../../common/api/getUserInfo';
import { TrialActivationSuccessModal } from './TrialActivationSuccessModal';
import { jsx as _jsx } from "react/jsx-runtime";
const TrialActivationSuccessContainer = ({
  onSuccess,
  upgradeData,
  showTrialLoadingState
}) => {
  const [featureData, setFeatureData] = useState({
    feature: undefined,
    fetched: false
  });
  const [hasInbound25Gate, setHasInbound25Gate] = useState();
  useEffect(() => {
    getUserInfo().then(userInfo => {
      setHasInbound25Gate(userInfo.gates.includes(gate('SSM:Inbound25')));
    }).catch(e => Raven.captureException(e));
  }, []);
  useEffect(() => {
    if (upgradeData.feature) {
      getFeatureWithRPC({
        shortName: upgradeData.feature
      }).then(feature => {
        setFeatureData({
          feature,
          fetched: true
        });
      }).catch(error => {
        setFeatureData({
          feature: undefined,
          fetched: true
        });
        console.error(error);
      });
    } else {
      setFeatureData({
        feature: undefined,
        fetched: true
      });
    }
  }, [upgradeData]);
  if (hasInbound25Gate === undefined) {
    return null;
  }
  return /*#__PURE__*/_jsx(TrialActivationSuccessModal, {
    showTrialLoadingState: showTrialLoadingState && !featureData.fetched,
    onSuccess: onSuccess,
    upgradeData: upgradeData,
    featureData: featureData.feature,
    hasInbound25Gate: hasInbound25Gate
  });
};
export default TrialActivationSuccessContainer;